import { ActionButton, CudaDialogTitle, LoadingDialogContent } from 'common/components/CudaDialog'

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import Grid from '@material-ui/core/Grid';
import React from 'react';
import moment from 'moment'
import { withStyles } from '@material-ui/core/styles';
import { Typography, Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import Chip from '@material-ui/core/Chip';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
const style = {
    root: {
        // maxWidth: '832px',
        '& input, textarea': {
            width: '100%',
        }
    },
    fieldLabel: {
        display: 'flex',
        alignItems: 'center'
    },
    fieldLabelDisabled: {
        extend: 'fieldLabel',
        color: 'rgba(0, 0, 0, 0.26)',
    },
    sectionHeader: {
        marginTop: '15px',
        color: 'rgba(0,0,0,0.9)',
        fontSize: '24px',
        fontWeight: 300,
        lineHeight: '28px'
    },
    toggleDiv: {
        marginTop: '15px',
    },
    disabledToggleHelptext: {
        fontSize: '12px',
        marginTop: '-11px',
        paddingLeft: '16px',
    },
    exceptionMessage: {
        marginTop: 5,
        color: '#ff1744',
        fontSize: '14',
        fontWeight: 400
    },
    fieldAlign: {
        paddingLeft: '4px',
    },
    labelButton: {
        backgroundColor: 'white',
        minWidth: '43px',
        minHeight: '20px',

    },
    labelButtonNormal: {
        extend: 'labelButton',
        width: '65px',
        height: '20px',
    },
    labelButtonTrial: {
        extend: 'labelButton',
        width: '43px',
        height: '20px',
    },
    labelButtonDeveloper: {
        extend: 'labelButton',
        width: '85px',
        height: '20px',
    },
    labelButtonMSP: {
        extend: 'labelButton',

    },
    labelButtonAWSmetered: {
        extend: 'labelButton',
        width: '115px',
        height: '20px',
    },
    labelButtonAWScontract: {
        extend: 'labelButton',
        width: '120px',
        height: '20px',
    },
    labelButtonAzureContract: {
        extend: 'labelButton',
        width: '140px',
        height: '20px',
    },
    labelButtonAzureMetered: {
        extend: 'labelButton',
        width: '140px',
        height: '20px',
    },
    daysBoxRoot: {
        height: '10px',
        margin: 0
    },
    violationChip: {
        // marginBottom: '10px',
        marginLeft: '5px',
        marginBottom: '3px',
    },
    violationChipColor: {
        color: 'red',
        borderColor: 'red',
    },
    violationsButton: {
        border: 'none'
    },
}

class AllowDenyDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = { daysValue: Array(props.licenses.length).fill("30") };
        this.setValue = this.setValue.bind(this);
    }

    componentDidUpdate(){
         //Initialize default value. licenses update after constructor,
         if(this.state.daysValue.length === 0) {
            this.props.licenses.forEach((val,i)=> this.setValue(i, 30));
        }
    }
    setValue(i, val) {
        var values = [...this.state.daysValue];
        values[i] = val;
        this.setState({ daysValue: values });
    }
    render() {
        const { classes, isOpen, loading, submitting,
            close,
            handleSubmit,
            account,
            licenses,
            licensesData,
            extendTrial,
            generateToken,
            requestStatus,
            removeRestrictions,
            removeRestrictionsResult,
        } = this.props;

        return (
            <form onSubmit={handleSubmit}>
                <Dialog open={isOpen} transitionDuration={0} maxWidth="xl" onClose={close} className={classes.root}>
                    <CudaDialogTitle onRequestClose={close}>
                        Options
                    </CudaDialogTitle>
                    <LoadingDialogContent loading={loading || submitting}>
                        <Grid container alignItems='center'>
                            <Grid container item alignItems="center">
                                <Grid item container alignItems='center' justify="flex-end">
                                    <Grid item container xs={12} alignItems='center'>
                                        <Typography variant='subtitle2' style={{ display: 'inline-block', marginRight: '5px' }}>Login As: </Typography>
                                        {account &&
                                            <a href={account.login_url}
                                                target="_blank" rel="noopener noreferrer">
                                                <Typography variant="caption" style={{ display: 'inline-block' }}>{account.name} ({account.id})</Typography>
                                            </a>
                                        }
                                        {!account.login_url &&
                                            <Button className={classes.actionButton} onClick={() => { generateToken(account.id) }}>
                                                Generate Token
                                            </Button>
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} style={{ marginTop: 20 }}>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell variant="head">
                                                <Grid container justify="space-between">
                                                    <Grid item xs={3}>Applications</Grid>
                                                    <Grid item xs={3}>Bandwidth</Grid>
                                                </Grid>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                {licensesData &&
                                                <Grid container justify="space-between">
                                                    <Grid item xs={3}>{licensesData['applications_count']} Used / {licensesData['applications_cap']} Licensed</Grid>
                                                    <Grid item xs={3}>{licensesData['total_bandwidth']} Mbps Licensed</Grid>
                                                </Grid>}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </Grid>
                            <Grid item container xs={12} style={{ marginTop: 20 }}>
                                <Grid item xs={12} className={classes.fieldLabel}>
                                    <Typography variant="subtitle2" style={{ marginBottom: '10px' }}> Licenses: </Typography>
                                </Grid>
                                <Grid container>
                                    {
                                        <Table>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell variant="head" style={{ paddingLeft: 0 }}>
                                                        <Grid container>
                                                            <Grid item xs={1}>Type</Grid>
                                                            <Grid item xs={1}>Serial</Grid>
                                                            <Grid item xs={1}>Applications</Grid>
                                                            <Grid item xs={3}>Expiration Date</Grid>
                                                            <Grid item xs={1}>Bandwidth</Grid>
                                                            <Grid item xs={1}>Plan</Grid>
                                                            <Grid item xs={2}>Assignment Date</Grid>
                                                        </Grid>
                                                    </TableCell>
                                                </TableRow>
                                                {licenses.map((license, i) => {
                                                    return (
                                                    <TableRow key={`rp#${i}`}>
                                                        <TableCell style={{ paddingLeft: '2px' }}>
                                                            <Grid container>
                                                                <Grid item xs={1}>
                                                                    {
                                                                        license.license_type === 'Trial' ? <Button size="small" className={classes.labelButtonTrial} variant='outlined' color="primary">TRIAL</Button> :
                                                                            license.license_type === 'Normal' ? <Button size="small" className={classes.labelButtonNormal} variant='outlined' color="primary">Normal</Button> :
                                                                                license.license_type === 'Developer' ? <Button size="small" className={classes.labelButtonDeveloper} variant='outlined' color="primary">DEVELOPER</Button> :
                                                                                    license.license_type === 'MSP' ? <Button size="small" className={classes.labelButtonTrial} variant='outlined' color="primary">MSP</Button> :
                                                                                        license.license_type === 'AWS Metered' ? <Button size="small" className={classes.labelButtonAWSmetered} variant='outlined' color="primary">AWS Metered</Button> :
                                                                                            license.license_type === 'AWS Contract' ? <Button size="small" className={classes.labelButtonAWScontract} variant='outlined' color="primary">AWS Contract</Button> :
                                                                                                license.license_type === 'Azure Metered' ? <Button size="small" className={classes.labelButtonAzureContract} variant='outlined' color="primary">Azure Metered</Button> :
                                                                                                    license.license_type === 'Azure Contract' ? <Button size="small" className={classes.labelButtonAzureContract} variant='outlined' color="primary">Azure Contract</Button> :
                                                                                                        <Button size="small" className={classes.labelButton} variant='outlined' color="primary">{license.license_type}</Button>

                                                                    }
                                                                </Grid>
                                                                <Grid item xs={1}>
                                                                    <Grid container alignItems="center">
                                                                        <Typography variant='caption' color='textSecondary'>{license.serial_number}</Typography>
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item xs={1}>{license.applications_ordered}</Grid>
                                                                <Grid item xs={3}>
                                                                    <Grid container spacing={2} alignItems="center">
                                                                        <Grid item container xs={12} alignItems="center">
                                                                            <Grid item style={{ width: '121px', marginRight: '16px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }}>

                                                                                {license.license_expiration_date &&
                                                                                    <Tooltip title={license.license_expiration_date}>
                                                                                        <div><Typography variant='caption' >{license.license_expiration_date}</Typography></div>
                                                                                    </Tooltip>
                                                                                }
                                                                            </Grid>
                                                                            <Grid item>
                                                                                {
                                                                                    license.license_type === 'Trial' ? moment(license.license_expiration_date).diff(license.associate_date, 'days') <= 90 ?
                                                                                        <Grid container direction="column" item alignItems='center'>
                                                                                            <Grid container alignItems='center' item xs={12}>
                                                                                                <Grid item>
                                                                                                    <Typography variant='caption' style={{ marginRight: '5px' }}>
                                                                                                        Request Extension of
                                                                                            </Typography>
                                                                                                </Grid>
                                                                                                <Grid item>
                                                                                                    <TextField
                                                                                                        id="outlined-basic"
                                                                                                        label=""
                                                                                                        margin="normal"
                                                                                                        variant="filled"
                                                                                                        size="small"
                                                                                                        onChange={(event) => this.setValue(i, event.target.value)}
                                                                                                        value={this.state.daysValue[i]}
                                                                                                        style={{ height: '20px', margin: 0 }}
                                                                                                        placeholder="30"
                                                                                                        defaultValue={this.state.daysValue[i]}
                                                                                                        InputLabelProps={{
                                                                                                            style: {
                                                                                                                height: '20px'
                                                                                                            }
                                                                                                        }}
                                                                                                        inputProps={{
                                                                                                            style: {
                                                                                                                height: '20px',
                                                                                                                width: '50px',
                                                                                                                padding: 0,
                                                                                                                fontSize: 'small',
                                                                                                                textAlign: 'center',
                                                                                                            }
                                                                                                        }}
                                                                                                    >

                                                                                                    </TextField>
                                                                                                </Grid>
                                                                                                <Grid item>
                                                                                                    Days
                                                                                        </Grid>
                                                                                                <Grid item>
                                                                                                    <ActionButton color="primary" onClick={() => extendTrial(account.id, license.id, this.state.daysValue[i])}>
                                                                                                        {
                                                                                                            license.id in requestStatus && requestStatus[license.id]['status'] === 'sending' &&
                                                                                                            <div><CircularProgress size={15} color="white" />&nbsp;&nbsp;</div>
                                                                                                        }
                                                                                                        {
                                                                                                            license.id in requestStatus && requestStatus[license.id]['status'] === 'sending' ? " APPLYING"
                                                                                                                : "APPLY"
                                                                                                        }
                                                                                                    </ActionButton>
                                                                                                    {
                                                                                                        license.id in requestStatus && requestStatus[license.id]['status'] === 'success' ? <Typography style={{ display: 'inline-block' }} variant='caption' color='secondary'>APPROVED </Typography>
                                                                                                            : license.id in requestStatus && requestStatus[license.id]['status'] === 'fail' ? <Typography style={{ display: 'inline-block' }} variant='caption' color='error'>ERROR </Typography> : ""
                                                                                                    }
                                                                                                </Grid>

                                                                                            </Grid>
                                                                                            <Grid item xs={12}>

                                                                                            </Grid>

                                                                                        </Grid> :
                                                                                        <Typography variant='caption' color='secondary'>You have used maximum of 90 days</Typography> :
                                                                                        ""
                                                                                }
                                                                            </Grid>
                                                                            <Grid item style={{ paddingLeft: '35%' }} className={classes.violationChip}>
                                                                                {
                                                                                    license.id in requestStatus &&
                                                                                        'error' in requestStatus[license.id] ? <Typography variant='caption' color='error'>{requestStatus[license.id]['error']}</Typography> : ""
                                                                                }
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item xs={1}>{license.additional_bandwidth_mbps}</Grid>
                                                                <Grid item xs={1}>{license.plan.name}</Grid>
                                                                <Grid item xs={2}>
                                                                    <Tooltip title={license.associate_date}>
                                                                        <div><Typography variant='caption' >{license.associate_date}</Typography></div>
                                                                    </Tooltip>
                                                                </Grid>
                                                            </Grid>
                                                        </TableCell>
                                                    </TableRow>)
                                                })}
                                            </TableBody>
                                        </Table>
                                    }
                                </Grid>
                            </Grid>
                            <Grid item container xs={12}>
                                <Grid item xs={12}>
                                    {
                                        account.violations &&
                                        <Typography variant='subtitle2' style={{ display: 'inline-block', paddingTop: '10px' }}>Violations:</Typography>
                                    }

                                    {
                                        account.violations &&
                                        (removeRestrictionsResult && removeRestrictionsResult["status"] ?
                                            <Button color="primary" onClick={() => removeRestrictions(account.id)} className={classes.violationsButton} size="small" >{removeRestrictionsResult["status"]}</Button>
                                            : <Button color="primary" onClick={() => removeRestrictions(account.id)} className={classes.violationsButton} size="small" >Remove Restrictions</Button>)
                                    }

                                </Grid>
                                <Grid item>
                                    {
                                        account.violations && <Chip variant='outlined'
                                            className={classes.violationChip}
                                            classes={{ colorPrimary: classes.violationChipColor }}
                                            color="primary"
                                            size="small"
                                            label={account.violations.violation_type}></Chip>

                                    }

                                </Grid>
                            </Grid>

                        </Grid>
                    </LoadingDialogContent>
                    <DialogActions>
                        <ActionButton onClick={close}>
                            Close
                        </ActionButton>
                    </DialogActions>

                </Dialog>
            </form>
        );

    }
}

export default withStyles(style, { name: 'allowDenyDialog' })(AllowDenyDialog);
